// UI copy for the "Update Delivery Location" feature (DEV-2580 / DEV-4281).
// Kept out of the appConstants barrel so the strings sit with the feature that owns
// them, matching the per-feature constants convention (mapConstants, markerConstants…).

export const DIVERT_LABEL = 'Divert';
export const UPDATE_DELIVERY_LOCATION_TITLE = 'Update Delivery Location';
export const DELIVERY_LOCATION_SELECT_PLANT = 'Select a plant';
export const DELIVERY_LOCATION_ENTER_ADDRESS = 'Enter an address';
export const DELIVERY_LOCATION_PLANT_HINT = 'Search plants…';
export const DELIVERY_LOCATION_CONFIRM = 'Update the delivery location for this ticket?';
export const DELIVERY_LOCATION_UPDATE_SUCCESS = 'Delivery location updated.';
export const DELIVERY_LOCATION_UPDATE_ERROR = 'Unable to update the delivery location.';
export const DELIVERY_LOCATION_SELECT_MATCH = 'Select the matching address';
export const DELIVERY_LOCATION_SEARCHING = 'Searching addresses…';
export const DELIVERY_LOCATION_NO_MATCHES =
  'No matching addresses found. Try a more specific address.';
export const DELIVERY_LOCATION_LOOKUP_ERROR = 'Unable to look up that address. Please try another.';
export const DELIVERY_LOCATION_ADDRESS_PROMPT = 'Enter an address to see matching locations';
